import { TranslationService, type Language } from "./translation-service.ts";
import { applyTranslations } from "./utils.ts";

const DEFAULT_LANGUAGE_ARRAY: Language[] = ["ru", "en"];

export const translationService = new TranslationService({
  fallbackLanguage: "en",
  langArr: DEFAULT_LANGUAGE_ARRAY,
});

export const t = translationService.createReactiveTranslations();

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => applyTranslations(t));
} else {
  applyTranslations(t);
}
